import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section id="top" className="flex min-h-[calc(100svh-3.75rem)] bg-brand-main px-4 py-7 text-center sm:py-8" data-id="element-82" data-mp="2hvm4m8t8rmbp">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.58,
      ease: [0.22, 1, 0.36, 1]
    }} className="mx-auto flex w-full max-w-4xl flex-col items-center justify-center" data-id="element-83" data-mp="23x4lypi7100n">
        <p className="mb-2 text-[10px] font-extrabold tracking-[0.2em] text-brand-moss sm:text-xs" data-id="element-84" data-mp="30k984mvrs3n6">
          DE COMPLETE HOCKEYMETHODE
        </p>
        <h1 className="mx-auto max-w-5xl text-[2.15rem] font-black leading-[1.04] tracking-tight text-brand-green sm:text-[3.4rem] md:text-[3.75rem]" data-id="element-85" data-mp="2ms31psif5b0x">
          Train een Heel Seizoen{' '}
          <span className="italic text-brand-goldink" data-id="element-86" data-mp="3fgi5tk00i8xh">Hockey</span> in Slechts 5
          Minuten Voorbereiding
        </h1>
        <p className="mx-auto mt-3 max-w-4xl text-sm leading-relaxed text-brand-gray sm:text-base md:text-lg" data-id="element-87" data-mp="2ff8w2yubigy2">
          Hockey Ready is een complete, kant-en-klare hockeymethode — 10 volumes
          vol theorie, oefeningen, spelvormen en evaluaties, van 6 tot 16 jaar.
          Gewoon printen, openen en trainen.
        </p>
        <img src="https://cdn.magicpatterns.com/uploads/fkaLGpb5V2dT3VhHmzbWjx/Mockup-Photoroom.png" alt="Het Hockey Ready-pakket met tien volumes, digitaal lesmateriaal, hockeymaterialen en vijf bonussen" className="mx-auto my-2 h-[37svh] w-auto max-w-full object-contain sm:my-3 sm:h-[40svh] md:h-[43svh]" data-id="element-88" data-mp="2kdk5x9km4rga" />
        <div className="flex w-full flex-col items-center" data-id="element-89" data-mp="3823apf4gem3m">
          <CTAButton className="min-w-[204px] px-4 py-2 text-[9px] shadow-sm sm:min-w-[224px] sm:px-5 sm:py-2.5 sm:text-[10px]" data-id="element-90" data-mp="336earaoiv36s">
            BESTEL HET HOCKEY READY-PAKKET
          </CTAButton>
          <p className="mt-2 max-w-xl text-center text-[9px] font-semibold leading-relaxed text-brand-gray sm:text-[10px]" data-id="element-91" data-mp="18s4z0xwunavi">
            ✓ Direct digitaal downloaden{' '}
            <span className="px-1 text-brand-orange" data-id="element-92" data-mp="3ds64fpjn1hne">·</span> ✓ Printklare
            PDF&apos;s <span className="px-1 text-brand-orange" data-id="element-93" data-mp="3iriok2j4kama">·</span> ✓
            Eenmalige betaling
          </p>
        </div>
      </motion.div>
    </section>;
}